export const FinancialSupportIds = Object.freeze({
    '$SUB': 'SUBMITTED',
    '$APR': 'APPROVED',
    '$CAN': 'CANCELLED',
    '$REV': 'REVIEW',
    '$HLD': 'HOLD',
    '$GOV': 'GOVERNMENT',
    '$INV': 'INVALID',
    'AVAILABLE': 'AVAILABLE',
    'INELIGIBLE': 'INELIGIBLE',
  });

export const FinancialSupportStatus = Object.freeze({
    SUBMITTED: '$SUB',
    APPROVED: '$APR',
    CANCELLED: '$CAN',
    REVIEW: '$REV',
    HOLD: '$HLD',
    GOVERNMENT: '$GOV',
    INVALID: '$INV',
    AVAILABLE: 'AVAILABLE',
    INELIGIBLE: 'INELIGIBLE',
    NA: 'NA', // Not Entered
});  

export const FinancialSupportStatusKeyByValue = Object.freeze(Object.fromEntries(Object.entries(FinancialSupportStatus).map(([key, value]) => [value, key])));
